<template>
  <div id="leaseagreement">
    <div id="content">
      <h1>Statistieken</h1>

      <div class="card-columns">
        <div class="card widget">
          <h2 class="card-title">Aantal inzetten</h2>

          <div class="card-body">
            <div class="row">
              <div class="col-6 widget__block dark p-3">
                <h3>Inzetten</h3>

                <div class="text-large">
                  53
                </div>

                <div class="text-small">
                  0 (-00%)
                </div>
              </div>

              <div class="col-6 widget__block light p-3">
                <h3>Vervallen</h3>

                <div class="text-large">
                  2
                </div>

                <div class="text-small text-red">
                  3 (-00%)
                </div>
              </div>
            </div>
            <h2>Bezettingsgraad</h2>

            <div class="row">
              <div class="col-6">
                <canvas id="bezettingsgraad-huidige" class="chartjs"></canvas>
              </div>

              <div class="col-6">
                <canvas
                  id="bezettingsgraad-vergelijkingsperiode"
                  class="chartjs"
                ></canvas>
              </div>
            </div>
          </div>
        </div>

        <div class="card widget">
          <h2 class="card-title">Aantal per categorie</h2>
          <div class="card-body">
            <div class="widget__block light p-3">
              <div class="text-small">
                Totaal aantal depots: 23 stuks
              </div>

              <div class="text-small">
                Totaal aantal inzetten: 300 stuks
              </div>
            </div>
            <canvas id="aantalpercategory" class="chartjs"></canvas>
          </div>
        </div>

        <div class="card widget">
          <h2 class="card-title">Ratio</h2>
          <div class="card-body">
            <div class="row">
              <div class="col-6 widget__block dark p-3">
                <h3>Gemiddeld 1/1</h3>

                <div class="text-large">
                  61.52
                </div>

                <div class="text-small">
                  0 (-00%)
                </div>
              </div>

              <div class="col-6 widget__block light p-3">
                <h3>Periodiek</h3>

                <div class="text-large">
                  65,99
                </div>

                <div class="text-small text-red">
                  3 (-00%)
                </div>
              </div>
            </div>
            <canvas id="ratio" class="chartjs"></canvas>
          </div>
        </div>

        <div class="card widget">
          <h2 class="card-title mb-3">Aantal per depot</h2>

          <div class="card-body">
            <div class="widget__block light p-3">
              <div class="text-small">
                Totaal aantal depots: 85 stuks
              </div>

              <div class="text-small">
                Totaal aantal inzetten: 299 stuks
              </div>
            </div>
            <canvas id="aantalperdepot" class="chartjs"></canvas>
          </div>
        </div>

        <div class="card widget">
          <h2 class="card-title">Aantal per periode</h2>

          <div class="card-body">
            <div
              id="carouselExampleIndicators"
              class="carousel dashboard-slider slide"
              data-ride="carousel"
            >
              <ol class="carousel-indicators">
                <li
                  data-target="#carouselExampleIndicators"
                  data-slide-to="0"
                  class="active"
                ></li>
                <li
                  data-target="#carouselExampleIndicators"
                  data-slide-to="1"
                ></li>
                <li
                  data-target="#carouselExampleIndicators"
                  data-slide-to="2"
                ></li>
              </ol>

              <div class="carousel-inner">
                <div class="carousel-item active">
                  <div class="row">
                    <div class="col-6 widget__block dark p-3">
                      <h3>Gemiddeld 1/1</h3>

                      <div class="text-large">
                        61.52
                      </div>

                      <div class="text-small">
                        0 (-00%)
                      </div>
                    </div>

                    <div class="col-6 widget__block light p-3">
                      <h3>Periodiek</h3>

                      <div class="text-large">
                        65,99
                      </div>

                      <div class="text-small text-red">
                        3 (-00%)
                      </div>
                    </div>
                  </div>
                </div>

                <div class="carousel-item">
                  <div class="widget__block light p-3">
                    <h3>Gemiddeld 1/1</h3>

                    <div class="text-large">
                      61.52
                    </div>

                    <div class="text-small">
                      0 (-00%)
                    </div>
                  </div>
                </div>

                <div class="carousel-item">
                  <div class="widget__block light p-3">
                    <h3>Gemiddeld 1/1</h3>

                    <div class="text-large">
                      61.52
                    </div>

                    <div class="text-small">
                      0 (-00%)
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card widget">
          <h2 class="card-title">Inzetduur</h2>

          <div class="card-body">
            <div
              id="inzetslider"
              class="carousel dashboard-slider slide"
              data-ride="carousel"
            >
              <ol class="carousel-indicators">
                <li
                  data-target="#inzetslider"
                  data-slide-to="0"
                  class="active"
                ></li>
                <li data-target="#inzetslider" data-slide-to="1"></li>
                <li data-target="#inzetslider" data-slide-to="2"></li>
              </ol>

              <div class="carousel-inner">
                <div class="carousel-item active">
                  <canvas id="inzetduur" class="chartjs mb-3"></canvas>
                </div>

                <div class="carousel-item">
                  <div class="widget__block light p-3">
                    <h3>Gemiddeld 1/1</h3>

                    <div class="text-large">
                      61.52
                    </div>

                    <div class="text-small">
                      0 (-00%)
                    </div>
                  </div>
                </div>

                <div class="carousel-item">
                  <div class="widget__block light p-3">
                    <h3>Gemiddeld 1/1</h3>

                    <div class="text-large">
                      61.52
                    </div>

                    <div class="text-small">
                      0 (-00%)
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card widget">
          <h2 class="card-title">Aantal per opdrachtgever</h2>

          <div class="card-body">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
              posuere erat a ante.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="/js/charts.js" type="text/javascript"></script>

<script>
export default {};
</script>
